export const SupportCategoriesEnum = {
  TUTORIALS: "Tutorials",
  DOCUMENTATION: "Documentation",
  CONTACTS: "Contacts",
};
